var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"example"}},[_c('hot-table',{ref:"hotTableComponent",attrs:{"data":_vm.data,"settings":_vm.hotSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }